import badWordsList from './words-list.json';

export function censorBadWords(s) {
  if (!s) return s;

  return badWordsList.reduce((censoredString, badWord) => {
    const regex = new RegExp(badWord, 'gi');
    return censoredString.replace(regex, new Array(badWord.length + 1).join('*'));
  }, s);
}
